import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { SignUpModel } from 'src/app/nutrigenic/models/auth/signup-model';
import { AuthService } from 'src/app/nutrigenic/services/auth/auth.service';

@Component({
  selector: 'app-signup-dialog',
  templateUrl: './signup-dialog.component.html',
  styleUrls: ['./signup-dialog.component.scss']
})
export class SignupDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() switchToLogin = new EventEmitter<void>();
  @Output() signupSuccess = new EventEmitter<number>();

  signupModel: SignUpModel = new SignUpModel();

  constructor(private authService: AuthService) {}

  handleHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  signUp() {
    if (this.signupModel.password.length >= 8 && this.signupModel.phone_number.length >= 9 && this.signupModel.password == this.signupModel.password_confirmation) {
      this.authService.signUp(this.signupModel).subscribe({
        next: (response: any) => {
          this.handleHide();
          this.signupSuccess.emit(response.body.id);
        },
        error: (error) => {
          Notify.failure('User already registered: ' + error.error.message, { position: 'right-top', timeout: 3000 });
        }
      });
    } else if (this.signupModel.password.length < 8) {
      Notify.failure('The password must be at least 8 characters', { position: 'right-top', timeout: 3000 });
    } else if (this.signupModel.phone_number.length < 9) {
      Notify.failure('The phone number must be at least 9 characters', { position: 'right-top', timeout: 3000 });
    } else if (this.signupModel.password != this.signupModel.password_confirmation) {
      Notify.failure('The password confirmation does not match', { position: 'right-top', timeout: 3000 });
    }
  }
}
